import { Redirect } from 'expo-router'

export default function LegacyTabsMe() {
  return <Redirect href="/profile" />
}
